<!--
<div class="dropdown position-fixed bottom-0 end-0 mb-3 me-3 bd-mode-toggle">
  <a href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" target="_blank" class="btn btn-bd-primary py-2  d-flex align-items-center"
          id="bd-theme"
          type="button"
          aria-expanded="false"
          aria-label="Toggle theme (auto)">
    <i class="bi bi-whatsapp"></i>
  </a>

</div>
-->


<a href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" class="float-wa" target="_blank">
  <i class="fa fa-whatsapp" style="margin-top:13px;"></i>
</a>
